var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"company-source-label mt-2",attrs:{"src":require('@/assets/images/Group 2419.svg'),"alt":"イベント申込済"}})])}
var staticRenderFns = []

export { render, staticRenderFns }